import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";
import {CommonDropdown} from "root/ReactHookForm/ui/CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {UserTypes} from "root/globals";

const DropdownUserTypes2 = ({onChange}) =>
{
    const fields = { url: '/school360/usertypes?role=' + UserTypes.USER_TYPE_SCHOOL_ADMIN, keyFieldName: 'type_id', labelFieldName: 'display_name' }

    const [ isLoading, items ] = useListboxFetch( fields ) ;

    return (
        <div>
            {isLoading === false && <CommonDropdown items={items} onChange={onChange}/>}
            {isLoading === true && <SpinnerDiv/>}
        </div>
    )
}

export default DropdownUserTypes2;